import { render, staticRenderFns } from "./tv.vue?vue&type=template&id=185efbe6&"
import script from "./tv.vue?vue&type=script&lang=js&"
export * from "./tv.vue?vue&type=script&lang=js&"
import style0 from "./tv.vue?vue&type=style&index=0&id=185efbe6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports